export default {
    dashboard: 'لوحة القيادة',
    profile: 'الملف الشخصي',
    home: 'بيت',
    users: 'المستخدمين',
    doctors: 'الأطباء',
    patients: 'مرضى',
    edit: 'يحرر',
    userSettings: 'إعدادات المستخدم',
    persian:'فارسي',
    english:'الإنجليزية',
    arabic:'العربية',
    available:'متوفرة',

    login:'تسجيل الدخول',
    logout:'تسجيل خروج',
    welcomeLogin:'مرحبا بك مرة أخرى، يرجى تسجيل الدخول إلى حسابك.',
    username:'اسم المستخدم',
    password:'كلمة المرور',
    loginButton:'تسجيل الدخول'
}